module.exports = __webpack_public_path__ + "static/media/sakura.fb31d3c2.png";